import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import * as React from 'react';
import createElement from "react-native-web/dist/exports/createElement";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import ExponentAV from "./ExponentAV";
export var FULLSCREEN_UPDATE_PLAYER_WILL_PRESENT = 0;
export var FULLSCREEN_UPDATE_PLAYER_DID_PRESENT = 1;
export var FULLSCREEN_UPDATE_PLAYER_WILL_DISMISS = 2;
export var FULLSCREEN_UPDATE_PLAYER_DID_DISMISS = 3;
export var IOS_FULLSCREEN_UPDATE_PLAYER_WILL_PRESENT = FULLSCREEN_UPDATE_PLAYER_WILL_PRESENT;
export var IOS_FULLSCREEN_UPDATE_PLAYER_DID_PRESENT = FULLSCREEN_UPDATE_PLAYER_DID_PRESENT;
export var IOS_FULLSCREEN_UPDATE_PLAYER_WILL_DISMISS = FULLSCREEN_UPDATE_PLAYER_WILL_DISMISS;
export var IOS_FULLSCREEN_UPDATE_PLAYER_DID_DISMISS = FULLSCREEN_UPDATE_PLAYER_DID_DISMISS;
var Video = React.forwardRef(function (props, ref) {
  return createElement('video', _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
});

var ExponentVideo = function (_React$Component) {
  _inherits(ExponentVideo, _React$Component);

  var _super = _createSuper(ExponentVideo);

  function ExponentVideo() {
    var _this;

    _classCallCheck(this, ExponentVideo);

    _this = _super.apply(this, arguments);

    _this.onFullscreenChange = function (event) {
      if (!_this.props.onFullscreenUpdate) return;

      if (event.target === _this._video) {
        if (document.fullscreenElement) {
          _this.props.onFullscreenUpdate({
            nativeEvent: {
              fullscreenUpdate: FULLSCREEN_UPDATE_PLAYER_DID_PRESENT
            }
          });
        } else {
          _this.props.onFullscreenUpdate({
            nativeEvent: {
              fullscreenUpdate: FULLSCREEN_UPDATE_PLAYER_DID_DISMISS
            }
          });
        }
      }
    };

    _this.onStatusUpdate = function _callee() {
      var nativeEvent;
      return _regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.props.onStatusUpdate) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return _regeneratorRuntime.awrap(ExponentAV.getStatusForVideo(_this._video));

            case 4:
              nativeEvent = _context.sent;

              _this.props.onStatusUpdate({
                nativeEvent: nativeEvent
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this.onLoadStart = function () {
      if (!_this.props.onLoadStart) {
        return;
      }

      _this.props.onLoadStart();

      _this.onStatusUpdate();
    };

    _this.onLoadedData = function (event) {
      if (!_this.props.onLoad) {
        return;
      }

      _this.props.onLoad(event);

      _this.onStatusUpdate();
    };

    _this.onError = function (event) {
      if (!_this.props.onError) {
        return;
      }

      _this.props.onError(event);

      _this.onStatusUpdate();
    };

    _this.onProgress = function () {
      _this.onStatusUpdate();
    };

    _this.onSeeking = function () {
      _this.onStatusUpdate();
    };

    _this.onEnded = function () {
      _this.onStatusUpdate();
    };

    _this.onLoadedMetadata = function () {
      _this.onStatusUpdate();
    };

    _this.onCanPlay = function (event) {
      if (!_this.props.onReadyForDisplay) {
        return;
      }

      _this.props.onReadyForDisplay(event);

      _this.onStatusUpdate();
    };

    _this.onStalled = function () {
      _this.onStatusUpdate();
    };

    _this.onRef = function (ref) {
      _this._video = ref;

      _this.onStatusUpdate();
    };

    return _this;
  }

  _createClass(ExponentVideo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isIE11 = !!window['MSStream'];
      document.addEventListener(isIE11 ? 'MSFullscreenChange' : 'fullscreenchange', this.onFullscreenChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var isIE11 = !!window['MSStream'];
      document.addEventListener(isIE11 ? 'MSFullscreenChange' : 'fullscreenchange', this.onFullscreenChange);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          source = _this$props.source,
          _this$props$status = _this$props.status,
          status = _this$props$status === void 0 ? {} : _this$props$status,
          objectFit = _this$props.resizeMode,
          useNativeControls = _this$props.useNativeControls,
          style = _this$props.style;
      var customStyle = {
        position: undefined,
        objectFit: objectFit,
        overflow: 'hidden',
        width: "100%",
        height: "100%"
      };
      return React.createElement(Video, {
        ref: this.onRef,
        onLoadStart: this.onLoadStart,
        onLoadedData: this.onLoadedData,
        onError: this.onError,
        onTimeUpdate: this.onProgress,
        onSeeking: this.onSeeking,
        onEnded: this.onEnded,
        onLoadedMetadata: this.onLoadedMetadata,
        onCanPlay: this.onCanPlay,
        onStalled: this.onStalled,
        src: (source || {
          uri: undefined
        }).uri,
        muted: status.isMuted,
        loop: status.isLooping,
        autoPlay: status.shouldPlay,
        controls: useNativeControls,
        style: [style, customStyle]
      });
    }
  }]);

  return ExponentVideo;
}(React.Component);

export { ExponentVideo as default };